<template>

  <main id="archive-material" class="section">
    <template v-if="recentMaterialsLoaded">
      <h2 class="title is-2">素材</h2>
      <div class="columns is-multiline is-mobile">
        <template v-for="post in recentMaterials(limit,paged)">
          <div class="column is-3-desktop is-4-tablet is-6-mobile">
            <material :post="post"></material>
          </div>
        </template>

      </div>

      <b-pagination order="is-centered" size="is-medium" :total="recentMaterialsTotal" :current.sync="current"
        :per-page="perPage" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page"
        aria-current-label="Current page">
      </b-pagination>

    </template>
    <Loader v-else />

  </main>
</template>

<script>
  // import _ from "lodash";
  import axios from "axios";
  import Loader from "../partials/Loader.vue";
  import Material from "../partials/Material.vue";
  import {
    mapGetters
  } from "vuex";
  import SETTINGS from "../../settings";
  // let paged = 1;

  const base_limit = 12;

  export default {
    // props: ["limit"],
    data() {
      let paged = this.$route.query.paged;
      if (!paged) {
        paged = 1;
      }
      let q = this.$route.query.q;
      if (!q) {
        q = null;
      }

      return {
        limit: base_limit,
        paged: paged,
        perPage: base_limit,
        total: 0,
        total_pages: 0,
        current: paged,
        materials: false,
        q: q
      };
    },

    watch: {
      '$route'() {
        // console.log("change q1");
        let q = this.$route.query.q;
        this.q = q;

        let paged = this.$route.query.paged;
        if (!paged) {
          paged = 1;
        }
        if (this.current != paged) {
          this.current = paged;
        }
      },
      q() {
        // console.log("change q2");
        this.changeRoute();
      },
      current() {
        this.changeRoute();
      }
    },

    computed: {
      ...mapGetters({
        recentMaterials: "recentMaterials",
        recentMaterialsLoaded: "recentMaterialsLoaded",
        recentMaterialsTotal: "recentMaterialsTotal"
      })
    },
    mounted() {
      // this.$store.dispatch("getMaterials", {
      //   limit: 10,
      //   paged: 1
      // });
      this.getMaterials();
    },
    // beforeMount() {
    //   // this.getMaterials();
    // },

    methods: {
      changeRoute: function () {
        let paged = this.current;
        let q = this.q;
        let arg = {}
        //paged
        if (paged > 1) {
          arg.paged = paged;
        }
        //search query
        if (q) {
          arg.q = q;
        }
        this.paged = paged;

        this.$router.push({
          query: arg
        });
        this.getMaterials();
      },
      getMaterials: function () {
        let paged = this.$route.query.paged;
        if (!paged) {
          paged = 1;
        }
        let q = this.$route.query.q;
        if (!q) {
          q = null;
        }
        // console.log("paged", paged, q);
        this.paged = paged;
        this.q = q;
        this.$store.dispatch("getMaterials", {
          limit: base_limit,
          paged: paged,
          q: q
        });
      }
    },

    components: {
      Loader,
      Material
    }
  };
</script>